import { Phone, MessageSquare, Calendar } from 'lucide-react';

export const MobileStickyBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#0a0a0a]/95 backdrop-blur-md border-t border-[#D4AF37]/30" data-testid="mobile-sticky-bar">
      <div className="grid grid-cols-3 divide-x divide-[#D4AF37]/20">
        <a
          href="tel:7863560878"
          className="flex flex-col items-center justify-center py-3 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors"
          data-testid="sticky-call-btn"
        >
          <Phone className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Call</span>
        </a>
        <a
          href="sms:7863560878"
          className="flex flex-col items-center justify-center py-3 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors"
          data-testid="sticky-text-btn"
        >
          <MessageSquare className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Text</span>
        </a>
        <a
          href="https://calendly.com/seantherealtor/15min"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors"
          data-testid="sticky-book-btn"
        >
          <Calendar className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Book</span>
        </a>
      </div>
    </div>
  );
};
